angular
    .module('WizApp')
    .component('cookieConsentLightbox', {
        controller: [
            '$scope',
            '$rootScope',
            'EVENT_NAMES',
            'LightboxStamp',
            'CookiesConsentService',
            ($scope, $rootScope, EVENT_NAMES, LightboxStamp, CookiesConsentService) => {
                const vm = LightboxStamp(this, $scope);
                const allTrue = {
                    connect_facebook: true,
                    connect_google: true,
                    analytics_facebook_pixel: true,
                    analytics_google: true,
                    analytics_hotjar: true
                };

                vm.cookiesAllServices = true;

                vm.setAllCookies = setAllCookies;
                vm.setSpecificCookies = setSpecificCookies;
                vm.checkConsents = checkConsents;

                vm.setCookiesConsent = CookiesConsentService.setCookiesConsent;

                function setAllCookies() {
                    if (vm.cookiesAllServices) {
                        vm.cookiesData = {
                            connect_facebook: true,
                            connect_google: true,
                            analytics_facebook_pixel: true,
                            analytics_google: true,
                            analytics_hotjar: true
                        };
                        vm.setCookiesConsent(vm.cookiesData);
                    }
                    else {
                        vm.cookiesData = {
                            connect_facebook: false,
                            connect_google: false,
                            analytics_facebook_pixel: false,
                            analytics_google: false,
                            analytics_hotjar: false
                        };
                        vm.setCookiesConsent(vm.cookiesData);
                    }
                }

                function setSpecificCookies() {
                    if (
                        !vm.cookiesData.connect_facebook ||
                        !vm.cookiesData.connect_google ||
                        !vm.cookiesData.analytics_facebook_pixel ||
                        !vm.cookiesData.analytics_google ||
                        !vm.cookiesData.analytics_hotjar
                    ) {
                        vm.cookiesAllServices = false;
                    }
                    else if (
                        vm.cookiesData.connect_facebook &&
                        vm.cookiesData.connect_google &&
                        vm.cookiesData.analytics_facebook_pixel &&
                        vm.cookiesData.analytics_google &&
                        vm.cookiesData.analytics_hotjar
                    ) {
                        vm.cookiesAllServices = true;
                    }
                    vm.setCookiesConsent(vm.cookiesData);
                }

                function checkConsents() {
                    CookiesConsentService.getCookiesConsent()
                        .then(data => {
                            vm.cookiesData = (data === null) ? allTrue : data;
                            if (
                                !vm.cookiesData.connect_facebook ||
                                !vm.cookiesData.connect_google ||
                                !vm.cookiesData.analytics_facebook_pixel ||
                                !vm.cookiesData.analytics_google ||
                                !vm.cookiesData.analytics_hotjar
                            ) {
                                vm.cookiesAllServices = false;
                            }
                            vm.open();
                        })
                    ;
                }

                $rootScope.$on(EVENT_NAMES.cookieConsentLightbox.open, () => {
                    checkConsents();
                });

                vm.cookiesData = null;

                return vm;
            }
        ],
        template:
        `
        <!--
        The v35/lightbox classes are doubled because without them, the animation on logged parts of 
        the site would not work.
        -->
        <div 
            class="v35 lightbox cookie-consent-lightbox"
            data-ng-if="$ctrl.isOpen"
        >
        <div
            class="v35 lightbox"
            data-ng-click="$ctrl.close()"
        >
            <div 
                class="lightbox__inner padding-gutter padding-vertical-large--sm-up padding-horizontal-larger--sm-up cookie-consent"
                data-ng-click="$event.stopPropagation()"
            >
            
                <div class="block block--radius-sm-up block--no-padding block--no-margin-bottom position-relative cookie-consent--inner">
                
                    <span class="lightbox__close-btn" data-ng-click="$ctrl.close()">
                        <span class="icon-cross"></span>
                    </span>
            
                    <div class="cookie-consent__header flexed flex flex--center margin-top-none--sm-up">
                        {{ 'wizbii.cookielightbox.header'|trans }}
                    </div>
                    
                    <div class="cookie-consent__main-text flexed flex flex--center">
                        <p class="margin-bottom-none">{{ 'wizbii.cookielightbox.paragraph1'|trans }}</p>
                        <p class="margin-bottom-none">{{ 'wizbii.cookielightbox.paragraph2'|trans }}</p>
                    </div>
                    
                    <div class="cookie-consent__all-services flexed flex flex--center">
                        <div class="cookie-consent__all-services__description">
                            {{ 'wizbii.cookielightbox.allserviceslabel'|trans }}
                        </div>
                        
                        <div class="cookie-consent__line"></div>
                        
                        <div class="cookie-consent__all-services__action">
                            <label class="cookie-consent__switch-button">
                                <input 
                                    class="ng-pristine ng-untouched ng-valid ng-not-empty" 
                                    type="checkbox"
                                    data-ng-model="$ctrl.cookiesAllServices"
                                    data-ng-click="$ctrl.setAllCookies()"
                                >
                                <span class="cookie-consent__switch-button__button"></span>
                                <span 
                                    class="cookie-consent__switch-button__labels"
                                    data-ng-class="{'cookie-consent__switch-button__labels--activated' : $ctrl.cookiesAllServices}"
                                >{{ 'wizbii.cookielightbox.activated'|trans }}</span>
                            </label>
                        </div>
                    </div>
                    
                    <hr class="cookie-consent__separator">
                    
                    <div class="cookie-consent__social-networks-header">
                        <b>{{ 'wizbii.cookielightbox.socialnetworkslabel'|trans }}</b>
                        <p>{{ 'wizbii.cookielightbox.socialnetworksparagraph'|trans }}</p>
                    </div>
                    
                    <div class="cookie-consent__specific-service flexed flex flex--center">
                        <div class="cookie-consent__specific-service__description">
                            Facebook
                        </div>
                        
                        <div class="cookie-consent__line"></div>
                        
                        <div class="cookie-consent__specific-service__action">
                            <label class="cookie-consent__switch-button">
                                <input 
                                    class="ng-pristine ng-untouched ng-valid ng-not-empty" 
                                    type="checkbox"
                                    data-ng-model="$ctrl.cookiesData.connect_facebook"
                                    data-ng-click="$ctrl.setSpecificCookies()"
                                >
                                <span class="cookie-consent__switch-button__button"></span>
                                <span 
                                    class="cookie-consent__switch-button__labels"
                                    data-ng-class="{'cookie-consent__switch-button__labels--activated' : $ctrl.cookiesData.connect_facebook}"
                                >{{ 'wizbii.cookielightbox.activated'|trans }}</span>
                            </label>
                        </div>
                    </div>
                    
                    <div class="cookie-consent__specific-service flexed flex flex--center">
                        <div class="cookie-consent__specific-service__description">
                            Google
                        </div>
                        
                        <div class="cookie-consent__line"></div>
                        
                        <div class="cookie-consent__specific-service__action">
                            <label class="cookie-consent__switch-button">
                                <input
                                    class="ng-pristine ng-untouched ng-valid ng-not-empty" 
                                    type="checkbox"
                                    data-ng-model="$ctrl.cookiesData.connect_google"
                                    data-ng-click="$ctrl.setSpecificCookies()"
                                >
                                <span class="cookie-consent__switch-button__button"></span>
                                <span 
                                    class="cookie-consent__switch-button__labels"
                                    data-ng-class="{'cookie-consent__switch-button__labels--activated' : $ctrl.cookiesData.connect_google}"
                                >{{ 'wizbii.cookielightbox.activated'|trans }}</span>
                            </label>
                        </div>
                    </div>
                    
                    <div class="cookie-consent__analytics-header">
                        <b>{{ 'wizbii.cookielightbox.analyticstoollabel'|trans }}</b>
                        <p>{{ 'wizbii.cookielightbox.analyticstoolparagraph'|trans }}</p>
                    </div>
                    
                    <div class="cookie-consent__specific-service flexed flex flex--center">
                        <div class="cookie-consent__specific-service__description">
                            Facebook Pixel
                        </div>
                        
                        <div class="cookie-consent__line"></div>
                        
                        <div class="cookie-consent__specific-service__action">
                            <label class="cookie-consent__switch-button">
                                <input 
                                    class="ng-pristine ng-untouched ng-valid ng-not-empty" 
                                    type="checkbox"
                                    data-ng-model="$ctrl.cookiesData.analytics_facebook_pixel"
                                    data-ng-click="$ctrl.setSpecificCookies()"
                                >
                                <span class="cookie-consent__switch-button__button"></span>
                                <span 
                                    class="cookie-consent__switch-button__labels"
                                    data-ng-class="{'cookie-consent__switch-button__labels--activated' : $ctrl.cookiesData.analytics_facebook_pixel}"
                                >{{ 'wizbii.cookielightbox.activated'|trans }}</span>
                            </label>
                        </div>

                    </div>
                    
                    <div class="cookie-consent__specific-service flexed flex flex--center">
                        <div class="cookie-consent__specific-service__description">
                            Google Analytics
                        </div>
                        
                        <div class="cookie-consent__line"></div>
                        
                        <div class="cookie-consent__specific-service__action">
                            <label class="cookie-consent__switch-button">
                                <input 
                                    class="ng-pristine ng-untouched ng-valid ng-not-empty" 
                                    type="checkbox"
                                    data-ng-model="$ctrl.cookiesData.analytics_google"
                                    data-ng-click="$ctrl.setSpecificCookies()"
                                >
                                <span class="cookie-consent__switch-button__button"></span>
                                <span 
                                    class="cookie-consent__switch-button__labels"
                                    data-ng-class="{'cookie-consent__switch-button__labels--activated' : $ctrl.cookiesData.analytics_google}"
                                >{{ 'wizbii.cookielightbox.activated'|trans }}</span>
                            </label>
                        </div>

                    </div>
                    
                    <div class="cookie-consent__specific-service flexed flex flex--center">
                        <div class="cookie-consent__specific-service__description">
                            Hotjar
                        </div>
                        
                        <div class="cookie-consent__line"></div>
                        
                        <div class="cookie-consent__specific-service__action">
                            <label class="cookie-consent__switch-button">
                                <input 
                                    class="ng-pristine ng-untouched ng-valid ng-not-empty" 
                                    type="checkbox"
                                    data-ng-model="$ctrl.cookiesData.analytics_hotjar"
                                    data-ng-click="$ctrl.setSpecificCookies()"
                                >
                                <span class="cookie-consent__switch-button__button"></span>
                                <span 
                                    class="cookie-consent__switch-button__labels"
                                    data-ng-class="{'cookie-consent__switch-button__labels--activated' : $ctrl.cookiesData.analytics_hotjar}"
                                >{{ 'wizbii.cookielightbox.activated'|trans }}</span>
                            </label>
                        </div>

                    </div>
                    
                </div>
                
            </div>    
        </div>
        </div>
        `
});
